"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Rating = require("../../../Hotel/components/Rating");
var _Alert = _interopRequireWildcard(require("../../../../../ui/Alert"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Reviews = function Reviews(_ref) {
  var averageRating = _ref.averageRating,
    turpravdaWidget = _ref.turpravdaWidget,
    shouldRenderError = _ref.shouldRenderError,
    sourceRatings = _ref.sourceRatings;
  var _useTranslation = (0, _reactI18next.useTranslation)(['OFFER_DETAILS', 'RESULT_CARD']),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !R.isEmpty(sourceRatings) && /*#__PURE__*/_react.default.createElement(_Rating.RatingList, {
    averageRating: averageRating,
    className: _styles.default.ratingList,
    itemClassName: _styles.default.ratingItem,
    title: t('RATING_LIST_TITLE'),
    sourceRatings: sourceRatings
  }), turpravdaWidget && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.turpravdaContainer,
    dangerouslySetInnerHTML: {
      __html: turpravdaWidget
    }
  }), shouldRenderError && /*#__PURE__*/_react.default.createElement(_Alert.default, {
    type: _Alert.TYPES.ERROR
  }, t('UPLOAD_REVIEWS_ERROR')));
};
Reviews.propTypes = {
  shouldRenderError: _propTypes.default.bool.isRequired,
  sourceRatings: _propTypes.default.array.isRequired,
  averageRating: _propTypes.default.number,
  turpravdaWidget: _propTypes.default.string
};
var _default = exports.default = (0, _react.memo)(Reviews);